import './App.scss';
import { RedocStandalone } from 'redoc';
import { useEffect, useState } from 'react';
import apiDescription from '!!raw-loader!./resources/descriptions/api-description.md';
import schemas ,{ EloomiSchema } from './resources/schemas';

function App() {
  const [schemaJson, setSchemaJson] = useState<any>(undefined);
  const schema = schemas[0]

  useEffect(() => {
      fetch(schema.schema)
        .then(async (response) => {
          const loadedSchema = await response.json();

          customizeSchema(loadedSchema);
          setSchemaJson(loadedSchema);
        })
  }, [])

  return (
    <div className="App">
      <RedocStandalone spec={schemaJson} options={{
        theme: {
          spacing: {
            sectionVertical: 20
          },
          typography: {
            fontFamily: "Proxima Nova",
            headings: {
              fontFamily: "Proxima Nova",
            }
          }
        }
      }}/>
    </div>
  );
}

function customizeSchema(schema: any) {
  schema.info.description = apiDescription;
}

export default App;
